// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellipsis_wjwMH {
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ugghhhhh */
.grow_OHCB7 {
  flex-grow: 1;
}

/* target last breadcrumb */
.breadcrumbs_ChPMe > div:last-child {
  display: flex;
  flex-grow: 1
}


/* button needs width 0 flex-grow 1 */
.growFromZero_HnZMd {
  width: 0;
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/item/MobileItemScreen.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb;AACF;;;AAGA,qCAAqC;AACrC;EACE,QAAQ;EACR,YAAY;AACd","sourcesContent":[".ellipsis {\n  flex-shrink: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ugghhhhh */\n.grow {\n  flex-grow: 1;\n}\n\n/* target last breadcrumb */\n.breadcrumbs > div:last-child {\n  display: flex;\n  flex-grow: 1\n}\n\n\n/* button needs width 0 flex-grow 1 */\n.growFromZero {\n  width: 0;\n  flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ellipsis": `ellipsis_wjwMH`,
	"grow": `grow_OHCB7`,
	"breadcrumbs": `breadcrumbs_ChPMe`,
	"growFromZero": `growFromZero_HnZMd`
};
export default ___CSS_LOADER_EXPORT___;
